import Util from 'client/util/Util';

export const FileUtilClass = class {
  constructor(customReader) {
    this.reader = customReader || new FileReader();
  }

  /**
   * Functions for manipulating files.
   */

  /**
    * @param {Object} input the input object.
    * @param {Number} maxSize the size limit for the file in bytes, e.g. 1024.
    */
  readFileInputValue(input, controls) {
    return new Promise((resolve, reject) => {
      this.reader.onload = (event) => {
        const rawContent = event.target.result;
        const base64Content = rawContent.substring(rawContent.indexOf(',') + 1);
        resolve(base64Content);
      };

      this.reader.onerror = () => {
        reject(new Error('Error reading the file'));
      };

      if (input.files.length > 0) {
        const { size, name } = input.files[0]; // bytes
        let { type } = input.files[0];
        if (size > controls.displayOptions.maxSize * 1024) {
          reject(new Error(`File size must not exceed ${Math.ceil(controls.displayOptions.maxSize / 1024)} MB. Upload a smaller file.`));
          return;
        }

        if (type === '') {
          type = name.split('.').pop();
        }
        const mappedType = Util.fileType(type);

        if (controls.displayOptions.type) {
          let fileTypes = [];
          let errorFlag = true;
          if (typeof (controls.displayOptions.type) === 'string') {
            fileTypes.push(controls.displayOptions.type);
          } else {
            fileTypes = controls.displayOptions.type;
          }

          fileTypes.forEach((fileType) => {
            if (fileType === mappedType) {
              errorFlag = false;
            }
          });

          if (errorFlag) {
            reject(new Error(`File type does not match requirement. Upload a .${(fileTypes.length > 1 ? (`${fileTypes.slice(0, fileTypes.length - 1).join(', ')} or ${fileTypes.slice(fileTypes.length - 1, fileTypes.length)}`) : fileTypes.slice(0, fileTypes.length))} file instead.`));
            return;
          }
        }

        this.reader.readAsDataURL(input.files[0]);
      }
    });
  }
};

export default new FileUtilClass();
